/*
 * @Author: JamesWong
 * @Description: 小票配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2021-03-18 20:05:44
 */
export default {
  styleDisposition: '樣式配置',
  ticketPreview: '小票預覽',
  createDeposit: '定金單',
  detail: '詳情',
  edit: '編輯',
  save: '保存',
  cancel: '取消',
  printLabel: '打印標示',
  reprintLabel: '重打印標示（僅在重打印的小票上顯示）',
  headPhotos: '頭部圖片',
  headPart: '頭部',
  ticketInfo: '單據資訊',
  ticketNo: '小票號',
  operateTime: '操作時間',
  cashier: '收銀員',
  assistant: '營業員',
  assistantCode: '營業員編號',
  assistantName: '營業員名稱',
  storeNo: '店鋪編號',
  storeAddr: '店鋪地址',
  storePhone: '店鋪電話',
  storeMobile: '店鋪手機',
  VIPNo: '會員編號',
  remarks: '銷售備註',
  Goods: '貨品',
  Quty: '數量',
  Amt: '金額',
  TagPrice: '吊牌價',
  Total: '合計',
  PriceTotal: '總額',
  Benefit: '優惠',
  VIPPrice: '會員價',
  DCT: '折扣',
  DiscountedPrice: '折後價',
  ValueBalance: '儲值余額',
  goodsInfo: '貨品信息',
  promotionInfo: '促銷資訊',
  allPromotionsTicket: '該單所有的促銷',
  promotionDesc: '促銷描述',
  promotionNotes: '促銷備註',
  paymentMethod: '支付方式',
  defaultPayment: '預設樣式：應付+所有應用到的支付方式',
  tailPhotos: '尾部圖片',
  salesExplanation: '銷售說明',
  tailpart: '尾部',
  quantitySet: '張數配置',
  salesCreateReciept: '銷售做單',
  numberChannelVersion: '店鋪聯列印張數',
  complete: '完成',
  numberCustomerVersion: '顧客聯列印張數',
  reprintSalesReciept: '重列印銷售單',
  tips: '提示',
  updatedTips: '更新小票配置成功',
  precept: '方案',
  cashierAndName: '收銀員：張三',
  assistantAndName: '營業員：1001-王曉',
  storeNoAndName: '店鋪編號：1009-店鋪',
  storeAddrAndName: '店鋪地址：廣州市番禺區天安節能科技園15號樓',
  payable: '應付',
  cash: '現金',
  integralBalance: '積分余額',
  printThirtpartOrder: '支付流水號',
  thridSeralNumber: '第三方支付的商戶支付流水號',
  TicketNumberEdited: '小票數修改成功！',
  TicketNumberEditedError1: '請輸入0-3之間的數字',
  TicketNumberEditedError2: '數量不能超過 3',
  photoUploadTips: '註：請先選擇圖片，可用鼠標滑動調整圖片的大小、位置，已達到理想打印效果。如超過邊框，圖片會按照300:130進行裁切。',
  selectPhotos: '選擇圖片',
  leftTurn: '向左旋轉',
  rightTurn: '向右旋轉',
  upload: '上傳',
  confirm: '確定',
  markSet: '標示設置',
  markSetMsg: '隱藏店鋪聯/顧客連"標示',
  markSetCustomer: '顧客聯',
  invoiceScanUrlText: '發票二維碼',
  invoiceScanUrl: '顯示發票二維碼(ERP配置後生效)',
  invoiceDesc: '发票發票',
  '添加二维码': '添加二維碼',
  '请输入二维码内容': '請輸入二維碼内容',
  '自定义二维码': '自定義二維碼',
  '二维码描述': '二維碼描述',
  '销售单号': '銷售單號',
  '手工单号': '手工單號',
  '会员卡号': '會員卡號',
  '会员手机': '會員手機',
  etc: '等',
  Coupon: '代用券',
  Date: '日期',
  printCoupons: '打印代用券',
  promoteCounpon: '促銷贈券',
  rechargeCounpon: '充值贈券',
  primeCostInfo: '原價總額',
  primeCostInfoDetail: '(貨品總吊牌價)',
  DiscountTotal: '優惠總額',
  alreadyDiscountInfo: '已優惠',
  alreadyDiscountInfoDetail: '(已優惠=吊牌價-應付)',
  实付: '實付',
  生意额: '生意額',
  getIntegrateInfo: '獲得積分',
  remainingIntegrateInfo: '積分餘額',
  uploadPhoto: '上傳圖片',
  autoSavePhoto: '自動生成條碼圖片',
  autoSelectNum: '選擇自動生成條形碼的單號',
  Saleno: '銷售單號',
  manualSaleNo: '手工單號',
  barCode: '條形碼',
  qrCode: '二維碼',
  takeCareMsg: '注意: 手工單號相對較長，轉成條形碼可能過長，導致掃描不出來，建議使用二維碼',
  cancelMsg: '取 消',
  saveMsg: '保 存',
  addParagraph: '+新增段落',
  addEmptyParagraph: '+新增空行',
  paragraphMsg: '段落',
  leftAlign: '左對齊',
  centerAlign: '居中',
  deleteMsg: '刪除',
  blankLine: '空行',
  // 3.4添加需求
  goodsSpace: '貨品顯示',
  goodsSpaceMsg: '货品之间空行隔开貨品之間空行隔開',
  showGoodsTotal: '貨品合計',
  showGoodsTotalMsg: '顯示合計',
  middlePic: '自定義圖片',
  tailImageDesc: '圖片描述',
  barCodeStyle: '條碼樣式',
  smallTicketNum: '小票號',
  goodsType10: '條形碼',
  goodsType10Unique: '唯壹碼',
  goodsType17: '條形碼/唯壹碼',
  goodsType2: '條形碼/品名',
  goodsType2Unique: '唯壹碼/品名',
  goodsType22: '條形碼/品類',
  goodsType22Unique: '唯壹碼/品類',
  goodsType4: '条形码/品名/吊牌价',
  goodsType4Unique: '唯壹碼/品名/吊牌价',
  goodsType44: '條形碼/品類/吊牌價',
  goodsType44Unique: '唯壹碼/品類/吊牌價',
  goodsType5: '条形码/品名/会员价/折后价',
  goodsType5Unique: '唯壹碼/品名/会员价/折后价',
  goodsType55: '條形碼/品類/會員價/折後價',
  goodsType55Unique: '唯壹碼/品類/會員價/折後價',
  goodsType7: '条形码/品名/会员价/折扣/折后价',
  goodsType7Unique: '唯壹碼/品名/会员价/折扣/折后价',
  goodsType77: '條形碼/品類/會員價/折扣/折後價',
  goodsType77Unique: '唯壹碼/品類/會員價/折扣/折後價',
  goodsType1: '货号-品名/颜色/内长/尺码',
  goodsType6: '货号-品名/颜色/内长/尺码/会员价/折后价',
  goodsType8: '货号-品名/颜色/内长/尺码/会员价/折扣/折后价',
  goodsType3: '货号-品名/颜色/内长/尺码/吊牌价',
  goodsType9: '货号-品名/颜色/内长/尺码/吊牌价/折扣/折后价',
  goodsType11: '貨號-品類/顏色/內長/尺碼',
  goodsType66: '貨號-品類/顏色/內長/尺碼/會員價/折後價',
  goodsType88: '貨號-品類/顏色/內長/尺碼/會員價/折扣/折後價',
  goodsType33: '貨號-品類/顏色/內長/尺碼/吊牌價',
  goodsType99: '貨號-品類/顏色/內長/尺碼/吊牌價/折扣/折後價',
  goodsType100: '货号-品类/颜色/内长/尺码/零售价/零售折扣/折后价',
  categoryReplaceName: '使用品類替換品名',
  uniqueReplaceBarcode: '使用唯壹碼替換條形碼',
  Amt_mang: '滿',
  Available: '可用',
  '渠道配置中心': '渠道配置中心',
  '单据打印样式管理': '單據打印樣式管理',
  '配置样式请至渠道配置中心操作': '配置樣式請至"渠道配置中心"操作',
  '单据': '單據',
  '新增简易版样式': '新增簡易版樣式',
  '新增定义版样式': '新增自定義版樣式',
  '简易版编辑器': '簡易版編輯器',
  '自定义编辑器': '自定義編輯器',
  '自定义版': '自定義版',
  '简易版': '簡易版',
  '空样式': '樣式',
  '样式名称': '樣式名稱',
  '样式文档名称': '樣式文檔名稱',
  '输入样式文档名称': '輸入樣式文檔名稱',
  '建议备注宽度以便区分': '建議備註寬度以便區分',
  '图片大小不超过': '圖片大小不超過',
  '选择单据': '選擇單據',
  '选择模版': '選擇模版',
  '空白模版': '空白模版',
  '请检查样式是否缺漏': '請檢查樣式是否缺漏',
  '您正在进行模版编辑操作, 是否放弃编辑?': '您正在進行模版編輯操作, 是否放棄編輯?',
  '销售单': '銷售單',
  '定金单': '定金單',
  '日结': '日結',
  '交接班': '交接班',
  '本机日收银': '本機日收銀',
  '充值单': '充值單',
  '调拨收货': '調撥收貨',
  '采购收货': '采購收貨',
  '渠道收货': '渠道收貨',
  '渠道调拨': '渠道調撥',
  '渠道退货': '渠道退貨',
  '仓库出货': '倉庫出貨',
  '渠道采购到货通知': '渠道采購到貨通知',
  '渠道调出通知': '渠道調出通知',
  '退货通知': '退貨通知',
  '渠道采购退货通知': '渠道采購退貨通知',
  '线上订单发货': '線上訂單發貨',
  '收货单': '收貨單',
  '成品采购入库单(基础)': '成品采購入庫單(基礎)',
  '发货单': '發貨單',
  '采购退货': '采購退貨',
  '紧急发货(基础)': '緊急發貨(基礎)',
  '配货单(基础)': '配貨單(基礎)',
  '发货退货(基础)': '發貨退貨(基礎)',
  '到货通知单(基础)': '到貨通知單(基礎)',
  '采购退货(基础)': '采購退貨(基礎)',
  '采购退货通知(基础)': '采購退貨通知(基礎)',
  '验货(基础)': '驗貨(基礎)',
  '自定义文本': '自定義文本',
  '模版名称': '模版名稱',
  '模板已保存': '模板已保存',
  '可通过渠道配置中心配置渠道使用': '可通過"渠道配置中心"配置渠道使用',
  '选择样式': '選擇樣式',
  '税额': '稅額',
  '显示税额': '顯示稅額',
  '买满立减(按单)': '買滿立減(按單)',
  '买满打折(按货品)': '買滿打折(按貨品)',
  '买满送优惠券': '買滿送優惠券',
  '顾客签名栏': '顧客簽名欄',
  '打印太阳码': '打印太陽碼',
  '显示顾客签名栏': '顯示顧客簽名欄',
  '显示已用代用券券号': '顯示已用代用券券號',
  '已用代用券': '已用代用券',
  '折扣取反(适用于非中国大陆地区)': '折扣取反(適用於非中國大陸地區)',
  '会员姓名': '會員姓名',
  '会员等级': '會員等級',
  '营业员(货品)': '營業員(貨品)',
  '代用券': '代用券',
  'A4显示货品营业员': 'A4显示货品营业员',
  '营业员': '營業員',
  '顾客签名': '顾客签名',
  '渠道调入': '渠道調入',
  '发货': '發貨',
  '配单': '配單',
  '退货': '退貨',
  '定金单号': '定金單號',
  '核销单号': '核銷單號',
  'printCounterChannelAbb': '专柜(商场打印)',
  'printCounterChannelAbbs': '专柜',
  '活动说明': '活動說明',
  '显示赠送代用券活动说明': '顯示贈送代用券活動說明',
  '批量打印': '批量打印',
  '顺丰面单打印': '顺丰面单打印',
  '零售配单验货': '零售配单验货',
  '销补发货': '销补发货',
  '收货工作台': '收货工作台',
  '线上订单工作台': '线上订单工作台',
  维修单: '维修单',
  补货: '补货',
  '发快递（影儿）': '发快递（影儿）',
  '价签打印': '價籤列印'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/slip.js